import LoginStateService, { LOGIN_CHANGE_EVENT, type LoginChangeDetail } from '../Service/LoginStateService'
import TrackingOptOutService from '../Service/TrackingOptOutService'
import { push } from '../Tracking/DataLayer'
import { observeDeclaredEvents } from '../Tracking/Declarative'
import { observeCheckout, trackPurchase } from '../Tracking/Ecommerce'

// A new tracking domain means a module under Tracking/ wired in here. Anything the server
// already knows needs no TypeScript at all — see Tracking/Declarative.ts.
class Tracking {
  public init(): void {
    TrackingOptOutService.syncTrackers()
    this.addEvents()

    this.pushLoginState(LoginStateService.isLoggedIn())
    observeDeclaredEvents()
    trackPurchase()
    observeCheckout()
  }

  private addEvents(): void {
    document.addEventListener(LOGIN_CHANGE_EVENT, (event: Event): void => {
      this.pushLoginState((event as CustomEvent<LoginChangeDetail>).detail.isLoggedIn)
    })
  }

  private pushLoginState(isLoggedIn: boolean): void {
    push({ loggedin: isLoggedIn ? 'yes' : 'no' })
  }
}

const tracking = new Tracking()
tracking.init()
